var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_495_954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9216 4.47063V3.87455C11.9216 3.03996 11.9216 2.62267 11.7591 2.3039C11.6163 2.0235 11.3883 1.79553 11.1079 1.65266C10.7891 1.49023 10.3718 1.49023 9.53725 1.49023H8.34509C7.51051 1.49023 7.09321 1.49023 6.77444 1.65266C6.49404 1.79553 6.26607 2.0235 6.1232 2.3039C5.96078 2.62267 5.96078 3.03996 5.96078 3.87455V4.47063M7.45098 8.56867V12.2942M10.4314 8.56867V12.2942M2.23529 4.47063H15.6471M14.1569 4.47063V12.8157C14.1569 14.0676 14.1569 14.6935 13.9132 15.1717C13.6989 15.5923 13.357 15.9343 12.9364 16.1486C12.4582 16.3922 11.8323 16.3922 10.5804 16.3922H7.30196C6.05008 16.3922 5.42413 16.3922 4.94598 16.1486C4.52538 15.9343 4.18342 15.5923 3.96912 15.1717C3.72549 14.6935 3.72549 14.0676 3.72549 12.8157V4.47063",
    stroke: "white",
    strokeWidth: 1.4902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_495_954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.8824,
    height: 17.8824,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash01);
export default __webpack_public_path__ + "static/media/trash-01.f756a8d5db6c936e0757209a0af7ba65.svg";
export { ForwardRef as ReactComponent };